<template>
  <div id="unicorn" >
  	<div class="bgdiv" v-html="info"></div>
  </div>

</template>

<script>
import protocoldesc from '@/assets/js/unicorn2024.js';
export default{
	name:'unicorn',
	data(){
		return {
			info:'',
			status:1
		}
	},
	created(){
	document.title = '发现独角兽';
    this.status = this.$route.query.status || 1;
    if(this.status == 1){
      this.info = protocoldesc.iosprivacy;
    }else if(this.status == 2){
      this.info = protocoldesc.iosserve;
    }
		// this.status = this.$route.query.status || 1;
	}
}



</script>
<style lang='scss'>
#unicorn{
	font-size:15px;
	width:100%;
	height:100%;
	position:absolute;
	overflow-y:auto;
	-webkit-overflow-scrolling: touch;
	.bgdiv{
		padding:10px;
	}
}
</style>
